<template>
  <div class="float-left header-add-icon">
    <router-link to="/add" v-if="show" class="d-block">
      <object class="plus-icon" :data="plusSvg" type="image/svg+xml"></object>
    </router-link>
  </div>
</template>

<script>
import { permissionMixin } from "@/mixins/permissionMixin";

export default {
  mixins: [permissionMixin],
  data() {
    return {
      plusSvg: require("../../../assets/svg/plus-icon.svg")
    };
  }
};
</script>
